import * as yup from "yup";

yup.setLocale({
  string: {
    required: "fieldRequired",
  },
});

export const MobileValidationSchema = yup.object().shape({
  mobile: yup.string().when("$isEditable", {
    is: true,
    then: (schema) =>
      schema
        .required("fieldRequired")
        .when("select", {
          is: "852",
          then: (s) =>
            s
              .matches(/^[4-9][0-9]{7}$/, "fieldRequired")
              .length(8, "fieldRequired"),
        })
        .when("select", {
          is: "853",
          then: (s) =>
            s
              .matches(/^[6][0-9]{7}$/, "fieldRequired")
              .length(8, "fieldRequired"),
        })
        .when("select", {
          is: "86",
          then: (s) =>
            s
              .matches(/^[1][0-9]{10}$/, "fieldRequired")
              .length(11, "fieldRequired"),
        }),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export const EarnSDollarValidationSchema = yup.object().shape({
  // invoice_number: yup
  //   .string()
  //   .required("fieldRequired")
  //   .when("purchase_shop", {
  //     is: (value) =>
  //       [
  //         "88",
  //         "87",
  //         "86",
  //         "85",
  //         "84",
  //         "82",
  //         "42",
  //         "44",
  //         "39",
  //         "40",
  //         "75",
  //       ].includes(String(value)), // ✅ 轉 string 處理數字/字串情況
  //     then: (schema) => schema.test((val) => !!val && val.startsWith("HK")),
  //     otherwise: (schema) => schema, // 其他值唔加限制
  //   }),
  invoice_number: yup
    .string()
    .required("fieldRequired")
    .test("hk-if-online", "invoice_number is invalid", function(val) {
      const type = this?.parent?.purchase_shop?.type; // 直接讀選中項目的 type

      if (type === "online") {
        // ✅ online → 必須 HK 開頭
        return !!val && /^HK/.test(val);
      }
      // else {
      //   // ✅ 非 online → 不可以 HK 開頭
      //   return !!val && !/^HK/.test(val);
      // }
      return true; // 非 online 放行
    }),
  purchase_date: yup.date().required("fieldRequired"),
  purchase_price: yup
    .number()
    .typeError("Price must be a number")
    .positive("Must be positive")
    .max(9999999999.99)
    .required("Price is required"),
  serial_number: yup.string().required("fieldRequired"),
  invoice_image: yup
    .mixed()
    .required("fieldRequired")
    .test("fileSize", "圖片檔案不能超過6MB", (file) => {
      return file && file.size <= 6 * 1024 * 1024;
    }),
  purchase_shop: yup.mixed().required("fieldRequired"),
});

export const EventFormValidationSchema = (hasMemberInfo, memberInfoData) => {
  const hasPhone = !!memberInfoData?.phone; // login 後 phone 有值 → 唔 check mobile
  const isMember = !!memberInfoData; // 有 memberInfoData → login 狀態
  return yup.object().shape({
    last_name: hasMemberInfo
      ? yup.string()
      : yup
          .string()
          .max(50, "fieldRequired")
          .required("fieldRequired"),

    first_name: hasMemberInfo
      ? yup.string()
      : yup
          .string()
          .max(50, "fieldRequired")
          .required("fieldRequired"),

    select: hasMemberInfo
      ? yup.string()
      : yup.string().required("fieldRequired"),

    mobile: hasPhone
      ? yup.string() // login 後且有 phone → 唔 check
      : yup
          .string()
          .required("fieldRequired")
          .when("select", {
            is: "852",
            then: (schema) =>
              schema
                .matches(/^[4-9][0-9]{7}$/, "fieldRequired")
                .length(8, "fieldRequired"),
          })
          .when("select", {
            is: "853",
            then: (schema) =>
              schema
                .matches(/^[6][0-9]{7}$/, "fieldRequired")
                .length(8, "fieldRequired"),
          })
          .when("select", {
            is: "86",
            then: (schema) =>
              schema
                .matches(/^[1][0-9]{10}$/, "fieldRequired")
                .length(11, "fieldRequired"),
          }),

    email: hasMemberInfo
      ? yup.string()
      : yup
          .string()
          .email("fieldRequired")
          .max(100, "fieldRequired")
          .required("fieldRequired"),

    event_name: yup.string().required("fieldRequired"),
    event_location: yup.string().required("fieldRequired"),
    event_date: yup.string().required("fieldRequired"),
    event_time: yup.string().required("fieldRequired"),

    tnc: yup
      .boolean()
      .default(isMember ? true : false)
      .oneOf([true], "fieldRequired"),
    promotion: yup.boolean(),
  });
};

export const WorkshopChangeValidationSchema = yup.object().shape({
  event_name: yup.string().required("fieldRequired"),

  event_location: yup.string().required("fieldRequired"),

  event_date: yup.string().required("fieldRequired"),

  event_time: yup.string().required("fieldRequired"),
});

const passwordSchema = yup
  .string()
  .required("fieldRequired")
  .min(8, "fieldRequired")
  .matches(/[A-Za-z]/, "fieldRequired")
  .matches(/\d/, "fieldRequired")
  .matches(/[^A-Za-z0-9]/, "fieldRequired");
// .test(
//   "no-more-than-3-repeats",
//   "Password cannot contain more than 3 repeated characters in a row",
//   (value) => {
//     if (!value) return true;
//     // 允許任意字元（包括英數特殊符號），連續 4 個相同就不行
//     return !/(.)\1{3,}/.test(value);
//   }
// )
// .test(
//   "no-more-than-3-consecutive",
//   "Password cannot contain more than 3 consecutive characters",
//   (value) => {
//     if (!value) return true;
//     const sequences = [
//       "abcdefghijklmnopqrstuvwxyz",
//       "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
//       "0123456789",
//     ];
//     return !sequences.some((seq) => {
//       for (let i = 0; i <= seq.length - 4; i++) {
//         const sub = seq.slice(i, i + 4);
//         if (value.includes(sub)) return true;
//       }
//       return false;
//     });
//   }
// );

export const ResetPasswordSchema = yup.object({
  password: passwordSchema,
  confirmPassword: yup
    .string()
    .required("fieldRequired")
    .oneOf([yup.ref("password")], "fieldRequired"),
});
